import { jsxs as l, jsx as o } from "react/jsx-runtime";
import { Carousel as m } from "../../../components/Carousel/index.js";
import { CustomRoot as c, CustomPrevButton as C, CommentSuggestionsCarouselCapsule as d, CustomNextButton as f } from "./style.js";
import { useTranslation as p } from "../../../hooks/useTranslation/index.js";
function v({
  className: s,
  suggestions: n,
  selectedSuggestionId: i,
  onSlide: a,
  onClickSuggestion: e,
  capsuleSize: u
}) {
  const { t: r } = p("common");
  return /* @__PURE__ */ l(c, { className: s, onMove: a, children: [
    /* @__PURE__ */ o(
      C,
      {
        "aria-label": r("comment-suggestions-carousel-back-button")
      }
    ),
    /* @__PURE__ */ o(m.List, { children: n.map((t) => /* @__PURE__ */ o(m.ListItem, { children: /* @__PURE__ */ o(
      d,
      {
        size: u,
        onClick: () => {
          e && e(t.id);
        },
        content: t.text,
        isSelected: t.id === i
      }
    ) }, t.id)) }),
    /* @__PURE__ */ o(
      f,
      {
        "aria-label": r("comment-suggestions-carousel-forward-button")
      }
    )
  ] });
}
export {
  v as CommentSuggestionsCarousel
};
